import actionCreatorFactory from "typescript-fsa";
import { ActiveCampaignRequestBody, ActiveCampaignResponse } from "../../core/api/requests/campaign/active/types";
import { CommonAsyncType } from "../../core/types";

const actionCreator = actionCreatorFactory("@@Campaign");

export const campaignActions = {
  fetchActiveCampaign: actionCreator.async<CommonAsyncType<ActiveCampaignRequestBody & ActiveCampaignResponse>, ActiveCampaignResponse>(
    "FETCH_ACTIVE_CAMPAIGN",
  ),
  resetToInitialState: actionCreator("RESET_TO_INITIAL_STATE"),
  markSelectionMade: actionCreator("MARK_SELECTION_MADE"),
};
